module.exports = __webpack_public_path__ + "img/crown.089c754b.png";